// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2uvt5","link":"Item_link__2CFVJ","title":"Item_title__tyfBy","preview":"Item_preview__zKZE0","content":"Item_content__2Qbzp","close":"Item_close__1WNsV"};